import useNewBrandContext from './context';
import NewBrandProvider from './provider';

export { NewBrandProvider };
export default useNewBrandContext;
